/* eslint-disable no-undef */
import React from 'react';
import PropTypes from 'prop-types';
import ValidateOrderEmailForm from './UncompletedOrderForm';
import Footer from '../Footer';
import './UncompletedOrderFormWrapper.sass';

const UncompletedOrderFormWrapper = (props) => {
  const {
    orderData, formAuthToken, locationsData, footerData, logoPath,
  } = props;
  const domainName = window.location.hostname;

  return (
    <div>
      <div className="container">
        <header>
          <a href="/">
            <img className="logoImage" src={logoPath} alt="main logo" />
          </a>
        </header>
      </div>

      <div className="content-container-email">
        <div className="background-image" />
        <div className="container">
          <div className="row">
            <div className="col-md-9 col-xs-12">
              <h2 className="mail-main-title">{I18n.t('sidebar.order.form.email-main-title')}</h2>
            </div>
            <div className="col-md-6 col-xs-12">
              <p>
                {I18n.t('sidebar.order.form.email-maintext')}
              </p>
              <ul className="email-selected-locations">
                {locationsData.map(elem => (
                  <li key={elem.id}>{elem.full_address}</li>
                ))}
              </ul>
              <p>
                {I18n.t('sidebar.order.form.email-textwith-domain')}
                &nbsp;
                <a href={domainName}>{domainName}</a>
              </p>
            </div>
          </div>

          <ValidateOrderEmailForm
            orderData={orderData}
            formAuthToken={formAuthToken}
          />
        </div>
      </div>


      <Footer footerData={footerData} />

    </div>
  );
};

UncompletedOrderFormWrapper.propTypes = {
  locationsData: PropTypes.arrayOf(PropTypes.object),
  orderData: PropTypes.oneOfType([PropTypes.object]),
  formAuthToken: PropTypes.string,
  logoPath: PropTypes.string,
  footerData: PropTypes.oneOfType([PropTypes.object]),
};

UncompletedOrderFormWrapper.defaultProps = {
  locationsData: [],
  formAuthToken: '',
  orderData: {},
  logoPath: '',
  footerData: {},
};

export default UncompletedOrderFormWrapper;
